import React from 'react';
import { CodeListing } from './CodeListing.styles';
import { BhiDialog } from 'src/UIKit';
import { DialogContent, Typography, Box } from '@mui/material';
import { CampaignConfigSchema } from '../../types';
import { toBackendConfig } from '../../helpers';

interface JsonPreviewModalProps {
  open: boolean;
  onClose: () => void;
  config: CampaignConfigSchema;
  isUpdate?: boolean;
}

/**
 * Previews the exact backend payload that will be saved (via saveTransform),
 * so the preview matches what the API receives rather than raw editor state.
 */
export const JsonPreviewModal: React.FC<JsonPreviewModalProps> = ({ open, onClose, config }) => {
  const formatJson = (obj: CampaignConfigSchema): string => {
    const payload = toBackendConfig(obj, obj.updatedAt || '');
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { components, ...rest } = payload;

    let configToFormat = rest;
    if (configToFormat.icon && configToFormat.icon.startsWith('data:image/') && configToFormat.icon.length > 30) {
      configToFormat = { ...configToFormat, icon: configToFormat.icon.substring(0, 30) + '...' };
    }

    return JSON.stringify(configToFormat, null, 2);
  };

  return (
    <BhiDialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      title="Campaign Configuration JSON"
      paperSx={{ height: '80vh', maxHeight: '80vh' }}
    >
      <DialogContent sx={{ p: 0, overflow: 'auto' }}>
        <Box p={3}>
          <Typography variant="body2" color="text.secondary" mb={2}>
            Real-time JSON representation of your campaign configuration:
          </Typography>
          <CodeListing sx={{ maxHeight: '60vh' }}>{formatJson(config)}</CodeListing>
        </Box>
      </DialogContent>
    </BhiDialog>
  );
};
